// Runs in the contact document's head while the React bundle is downloading.
// Its promise always settles successfully so an early HTTP failure cannot become
// an unhandled rejection before the calendar mounts.
export const bookingBootstrapScript = `(() => {
  if (window.__philBookingAvailabilityStarted || window.__philBookingAvailability) return;
  window.__philBookingAvailabilityStarted = true;
  const month = new Intl.DateTimeFormat('en-CA', { timeZone: 'Europe/London', year: 'numeric', month: '2-digit', day: '2-digit' }).format(new Date()).slice(0, 7);
  const startedAt = Date.now();
  const promise = fetch('/booking-api.php?action=availability&month=' + month, {
    credentials: 'same-origin', cache: 'no-store', signal: AbortSignal.timeout(90000)
  }).then(async response => {
    const value = await response.json();
    if (!response.ok) throw new Error(value.error || 'The calendars could not be checked. Please try again.');
    return { value };
  }).catch(() => ({ error: 'The calendars could not be checked. Please try again or use the contact form.' }));
  window.__philBookingAvailability = { month, startedAt, promise };
})();`;

declare global {
  interface Window {
    __philBookingAvailabilityStarted?: boolean;
    __philBookingAvailability?: {
      month: string;
      startedAt: number;
      promise: Promise<{ value?: unknown; error?: string }>;
    };
  }
}

export function takeEarlyBookingAvailability(month: string): Promise<unknown> | undefined {
  if (typeof window === "undefined") return;
  const early = window.__philBookingAvailability;
  delete window.__philBookingAvailability;
  if (early) window.__philBookingAvailabilityStarted = true;
  if (!early || early.month !== month || Date.now() - early.startedAt > 90000) return;
  return early.promise.then((result) => {
    if (result.error) throw new Error(result.error);
    return result.value;
  });
}
